import React, { useState } from "react";

const InvisibleRequest = ({ onChange, value }) => {
  const [invisible, setInvisible] = useState(value);
  return (
    <div>
      <label style={{ marginRight: "10px" }}>Invisible:</label>
      <input
        type="checkbox"
        checked={invisible}
        onChange={(e) => setInvisible(e.target.checked)}
      />
    </div>
  );
};

export default InvisibleRequest;
